export const formInitialValues = (data) => ({
  kodeJenis: data?.kode_jenis_anggaran ?? "",
  keterangan: data?.keterangan ?? "",
  namaJenis: data?.nama_jenis_anggaran ?? "",
  idJenis: data?.id_jenis_anggaran ?? "",
});
